// 存储配置接口列表数据（如 /common/config），带副作用的接口不可放在这里
// 配置接口 store，如语言/城市列表
import _ from 'lodash'
import { getCommonConfig } from '@/api/common'
import { getCountryList } from '@/api/common/country'
import { getCommonTimezone } from '@/api/common'
import { fetchFontList } from '@/api/common/font'
import { getLanguages } from '@/api/options'

export default {
  namespaced: true,

  state: {
    gmaker: {},
    countryList: [],
    timeZoneList: [],
    fontList: [],
    languages: [],

    // gmaker: {},
    // creative_provider: [],
  },

  actions: {
    /**
     * getCommonConfig
     * @param state
     * @param useCache {boolean}
     * @param names {string[]} 配置项数组
     * @returns {Promise<*>}
     */
    async getCommonConfig({ state }, { useCache = true, names = [] }) {
      // http://playable.dev.com:8066/common/config?names=creative_provider,traffic_limits
      let filterNames = [...names]
      // 使用缓存
      if (useCache) {
        // 从缓存中可以获取到所有数据
        if (
          (names.filter((name) => _.isEmpty(state[name])) || []).length === 0
        ) {
          return _.cloneDeep(_.pick(state, names))
        }
        // 从缓存中无法获取到所有数据
        filterNames = names.filter((name) => _.isEmpty(state[name]))
      }

      const res = await getCommonConfig({ names: filterNames.join(',') })
      const data = _.get(res, 'data.data')

      const utils = {
        creative_provider: {
          cooker: (list) => {
            return list.map((item) => {
              return {
                value: item.k,
                label: item.v,
              }
            })
          },
        },
      }

      _.each(filterNames, (key) => {
        const cooker = _.get(utils, `${key}.cooker`)
        // 需要特殊加工
        if (_.isFunction(cooker)) {
          state[key] = cooker(data[key])
        } else {
          // 默认直接赋值即可
          state[key] = data[key]
        }
      })
      return _.cloneDeep(_.pick(state, names))
    },

    async getGmakerConfig({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['gmaker'],
      })
      return _.get(res, 'gmaker')
    },

    async getCreativeProvider({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['creative_provider'],
      })
      return _.get(res, 'creative_provider')
    },

    async getGrantConfig({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['grant'],
      })
      return _.get(res, 'grant')
    },

    async getInteractionTagsConfig({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['interaction_tags'],
      })
      return _.get(res, 'interaction_tags')
    },

    async getCountryList({ state }, useCache = true) {
      if (useCache && !_.isEmpty(state.countryList)) return state.countryList
      const res = await getCountryList()
      state.countryList = (_.get(res, 'data.data.list') || []).map((item) => {
        const country = {
          ...item,
          value: item.code,
          label: item.name,
        }
        delete country.code
        delete country.name
        return country
      })
      return state.countryList
    },

    async getTimeZoneList({ state }, useCache = true) {
      if (useCache && !_.isEmpty(state.timeZoneList)) return state.timeZoneList
      const res = await getCommonTimezone()
      state.timeZoneList = (_.get(res, 'data.data.timezone') || []).map(
        (item) => {
          const timezone = {
            ...item,
            value: item.code,
            label: item.name,
          }
          delete timezone.code
          delete timezone.name
          return timezone
        },
      )
      return state.timeZoneList
    },

    async getFontList({ state }, useCache = true) {
      if (useCache && !_.isEmpty(state.fontList)) return state.fontList
      const res = await fetchFontList()
      const list = _.uniqWith(_.get(res, 'data.data.list') || [], _.isEqual)
      state.fontList = list
      return list
    },

    async getLanguagesList({ state }, useCache = true) {
      if (useCache && !_.isEmpty(state.languages)) return state.languages
      const res = await getLanguages()
      const list = _.get(res, 'data.data.list') || []
      state.languages = list
      return list
    },

    async getVeditorConfig({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['veditor'],
      })
      return _.get(res, 'veditor')
    },
  },
}
